"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingComponent = void 0;
const core_1 = require("@angular/core");
const loading_service_1 = require("./loading.service");
const platform_browser_1 = require("@angular/platform-browser");
let LoadingComponent = class LoadingComponent {
    loadingProgress() {
        let load = 0;
        if (this._loading.current() && this._loading.total())
            load = (Math.round(this._loading.current() * (1 / this._loading.total() * 100) * 100)) / 100;
        return load;
    }
    constructor(document, _loading) {
        this.document = document;
        this._loading = _loading;
        this.isEmxHost = null;
        this.isEmxHost = /(.emxdigital.com)/gi.test(this.document.location.host);
    }
};
exports.LoadingComponent = LoadingComponent;
exports.LoadingComponent = LoadingComponent = __decorate([
    (0, core_1.Component)({
        selector: 'my-loading',
        styleUrls: ['styles/loading.component.css'],
        template: `
	<div *ngIf="isEmxHost!==null" class="loadingOverlay" [hidden]="!_loading.status()">
    <div class="loadingModal loadingModalDark">
      <div class="cadentLogo"><img src="img/CadentLogo_Reverse_RGB.svg"/></div>
      <div *ngIf="_loading.incrementalProgress" class="loadingBar">
        <progressbar class="loadingBar progress-striped progress-bar-animated active" [value]="loadingProgress()" [type]="info"></progressbar> 		
        <div class="alert-info infoBlock">{{_loading.getMessage()}}...</div>
      </div>
    </div>
	</div>
	`
    }),
    __param(0, (0, core_1.Inject)(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [Object, loading_service_1.LoadingService])
], LoadingComponent);
//# sourceMappingURL=loading.component.js.map